<div class="app-wrapper relative" [dir]="'rtl'">
  <div *ngIf="isCheckInLoading$ | async" class="app-lottie-wrapper check-in-loader">
    <ng-lottie
      [options]="lottieOptions"
      width="200px"
      height="200px"
      [styles]="lottieCheckInStyles"
    ></ng-lottie>
  </div>

  <router-outlet></router-outlet>
</div>
